export default __webpack_public_path__ + "static/media/tip3.add7e4c6.png";